<template>
  <div class="wrapper">
    <div class="circle-icon-wrapper">
      <div class="circle-icon">
        <img class="circle-icon-image" :src="icon">
      </div>
    </div>
    <div>
      <div class="title">
        {{ title }}
      </div>
      <div class="description">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'IconDetail',
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
    .wrapper {
        display: flex;
        align-items: center;
    }

    .circle-icon-wrapper {
        margin-right: 24px;
    }

    .circle-icon {
        background: #6F4FFF;
        border-radius: 50%;
        padding: 21.875%;
    }

    .circle-icon-image {
        max-width: 100%;
        max-height: 100%;
    }

    .title {
        color: #48465B;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 8px;
    }

    .description {
        color: #9392A0;
        font-size: 14px;
        font-weight: 200;
    }
</style>
